import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { useRedirectToError } from '@/composables/useRedirectToError.js'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export const useUnauthenticatedTokenStore = defineStore(
  'unauthenticatedToken',
  () => {
    const { $apiUnauthenticatedRequest } = useApiRequestHelper()
    const router = useRouter()

    // States
    const token = ref(null)
    const tokenId = ref(null)
    const engineerCheckInAccessToken = ref(null)
    const sentTo = ref(null)

    const refresh = async (filters = {}) => {
      return await $apiUnauthenticatedRequest
        .get(
          'engineer-check-in-access-tokens',
          $apiUnauthenticatedRequest.configs.get
            .setId(tokenId.value)
            .setIncludes(['contractor', 'user']),
        )
        .then(({ data }) => {
          engineerCheckInAccessToken.value = data
        })
        .catch(async (error) => {
          await useRedirectToError(router).redirect()
        })
    }

    const reset = () => {
      token.value = null
      tokenId.value = null
      engineerCheckInAccessToken.value = null
      sentTo.value = null
    }

    return {
      token,
      tokenId,
      engineerCheckInAccessToken,
      sentTo,
      refresh,
      reset,
    }
  },
  { persist: true },
)
